class MarketPerformanceDetails {
    constructor(props) {
        const {
            volume,
            rises,
            falls,
            asAt,
            turnover,
            instrument,
            openingHours,
        } = props;

        this.volume = volume;
        this.rises = rises;
        this.falls = falls;
        this.asAt = asAt;
        this.turnover = {
            amount: turnover.amount,
            currency: turnover.currency,
        };
        this.instrument = {
            name: instrument.name,
            changeValue: {
                amount: instrument.changeValue.amount,
                currency: instrument.changeValue.currency,
            },
            closeValue: {
                amount: instrument.closeValue.amount,
                currency: instrument.closeValue.currency,
            },
            prices: {
                values: instrument.prices.values,
            },
            changePercentage: instrument.changePercentage,
        };
        this.isMarketOpen = openingHours?.isOpen;
        this.marketOpeningLabel = openingHours?.marketOpeningLabel;
    }
}

export default MarketPerformanceDetails;
